export default "__VITE_ASSET__39a36764__"